import { FC, ReactNode } from 'react'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Typography, IconButton, Button, Modal } from '@mui/material'

import styles from './styles.module.scss'

interface IProps {
  text: string
  btnText: string
  btnIcon?: ReactNode
  onClose: () => void
  onConfirm?: () => void
}

const ConfirmationModal: FC<IProps> = ({
  text,
  btnText,
  btnIcon = null,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal className={styles.modal} open onClose={onClose}>
      <Box className={styles.modalContent}>
        <Box>
          <Box className={styles.header}>
            <Typography data-testid="title" className={styles.title}>
              {text}
            </Typography>
            <IconButton data-testid="closeButton" onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Box>
          <Box className={styles.actions}>
            <Button onClick={onClose} startIcon={<CloseIcon />}>
              Cancel
            </Button>
            <Button
              id="confirmButton"
              data-testid="confirmButton"
              variant="contained"
              onClick={onConfirm}
              startIcon={btnIcon}
            >
              {btnText}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default ConfirmationModal
